import axios from 'axios';

import runtimeConfig from '@/common/runtime-config';

const DEFAULT_FILENAME = 'download';

export default {
  loadSelectOptions(dictName, optionsArray, requestData, isClear) {
    this.searchNsi(dictName, requestData).then(function (response) {
      if (isClear) {
        while (optionsArray.length > 1) optionsArray.pop();
      }

      if (response.data && response.data.length) {
        response.data.forEach((i) => optionsArray.push(i));
      }
    });
  },
  loadMultiSelectOptions(dictName, optionsArray, requestData, isClear) {
    this.searchNsi(dictName, requestData).then(function (response) {
      if (isClear) {
        while (optionsArray.length > 1) optionsArray.pop();
      }

      if (response.data && response.data.length) {
        response.data.map((i) =>
          optionsArray.push({
            value: i.id,
            label: i.text,
          }),
        );
      }
    });
  },
  searchNsi(dictName, requestData) {
    return axios.get('/api/nsi/' + dictName, { params: requestData });
  },
  async downloadFile(url, filename, params, nameFromParams, method = 'get') {
    const prepareMethod = String(method).toLowerCase();
    const options = { responseType: 'blob' };
    let request;

    if (prepareMethod === 'get') {
      if (params) {
        options.params = params;
      }
      request = axios.get(url, options);
    } else if (prepareMethod === 'post') {
      request = axios.post(url, params ?? {}, options);
    } else {
      throw new Error(`Unsupported method for downloadFile: ${prepareMethod}`);
    }

    return request.then((response) => {
      // Пустая выборка возвращается как application/json — файла нет
      if (String(response.data?.type ?? '').includes('application/json')) {
        return false;
      }

      const blob = new Blob([response.data], { type: response.data.type });
      const link = document.createElement('a');
      const contentDisposition = response.headers['content-disposition'];
      filename = filename || DEFAULT_FILENAME;
      if (contentDisposition && !nameFromParams) {
        const filenameFromHeader = getFilenameFromContentDisposition(contentDisposition);
        if (filenameFromHeader) {
          filename = filenameFromHeader;
        }
      }
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
      return true;
    });
  },
  getFileUrl(id) {
    const baseUrl = runtimeConfig.apiBaseUrl;
    return `${baseUrl}/api/file/download?id=${id}`;
  },
  getFileUrlGuid(guid) {
    const baseUrl = runtimeConfig.apiBaseUrl;
    return `${baseUrl}/api/file/downloadGuid?guid=${guid}`;
  },
  groupList(list, keyGetter, itemGetter) {
    let result = [];
    list.forEach((item) => {
      const key = keyGetter(item);
      if (key.id > 0) {
        let group = result.find((x) => x.id === key.id);
        if (!group) {
          group = { id: key.id, text: key.text, children: [] };
          result.push(group);
        }
        let child;
        if (typeof itemGetter === 'function') {
          child = itemGetter(item);
        } else {
          child = { id: item.id, text: item.name };
        }
        group.children.push(child);
      } else if (item.isLeaf) {
        result.push({ id: item.id, text: item.name });
      }
    });
    return result;
  },
  getPublicBaseUrl() {
    return runtimeConfig.publicBaseUrl;
  },
  async getAdminAccess() {
    return axios.get('/api/navigation/adminAccess');
  },
  async getRussianRegions() {
    const authUrl = runtimeConfig.apiAuthUrl;
    return axios.get(`${authUrl}/api/RegionOfRussia/Search`);
  },
  windowTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  getPreparedMobilePhone(phoneNumber) {
    if (!phoneNumber) return;
    return String(phoneNumber).replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 $2 $3-$4-$5');
  },
};
export const findItemNested = (arr, itemId, nestingKey) =>
  arr.reduce((a, item) => {
    if (a) return a;
    if (item.id == itemId) return item;
    if (item[nestingKey]) return findItemNested(item[nestingKey], itemId, nestingKey);
  }, null);

export const isEscape = (e) => e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;

const getFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) {
    return null;
  }

  const filenameStarMatch = contentDisposition.match(/filename\*=([^;]+)/i);
  if (filenameStarMatch) {
    const value = filenameStarMatch[1].trim().replace(/(?:^["']|["']$)/g, '');
    const rfc5987Match = value.match(/^([^']*)'[^']*'(.*)$/);

    try {
      const encodedName = (rfc5987Match ? rfc5987Match[2] : value.replace(/^UTF-8''/i, '')).trim();
      return decodeURIComponent(encodedName);
    } catch {
      return DEFAULT_FILENAME;
    }
  }

  const filenameMatch = contentDisposition.match(/(?:;\s*filename=([^;]+)|^filename=([^;]+))/i);
  if (filenameMatch) {
    let name = (filenameMatch[1] || filenameMatch[2]).trim();

    if (name.startsWith('"') && name.endsWith('"')) {
      name = name.slice(1, -1);
    }

    return name.replace(/\\"/g, '"');
  }

  return null;
};
